import { Link } from 'react-router-dom';
import { leadCategories } from '@/mocks/home';

export default function LeadCategories() {
  return (
    <section id="categories" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="w-full">
        <div className="max-w-2xl mb-12">
          <span className="font-heading text-sm tracking-widest text-primary-600">线索征集范围</span>
          <h2 className="mt-3 font-heading text-3xl md:text-5xl text-foreground-950 leading-tight">
            这八类线索，编辑一直在等
          </h2>
          <p className="mt-5 text-sm md:text-base leading-7 text-foreground-600">
            投稿入口不限制你必须来自娱乐圈。只要线索能被核实、能说明时间与场景，就值得一投。
            点开任意方向，可以直接带着这个方向的信息去填写投稿表单。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {leadCategories.map((c) => (
            <article
              key={c.name}
              className="group flex flex-col overflow-hidden rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="w-full h-40 overflow-hidden">
                <img
                  src={c.image}
                  alt={`${c.name}线索分类插图`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col flex-1 p-5">
                <div className="flex items-center gap-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${c.icon} text-lg`}></i>
                  </span>
                  <h3 className="text-base font-bold text-foreground-950">{c.name}</h3>
                </div>
                <p className="mt-3 text-sm leading-7 text-foreground-600 flex-1">{c.desc}</p>
                <Link
                  to={`/submit?type=${encodeURIComponent(c.name)}`}
                  className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  用这个方向投稿
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}